import styled from 'styled-components';

export const ComparePageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const CompareContentWrapper = styled.div`
  width: calc(100% - 48px);
  height: 100%;
  padding: 0px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 48px;
`;

export const CompareContentTitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const CompareContentBtnsWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const CompareContentTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: auto;
  margin-left: 16px;
  padding-top: 2px;
`;

export const CompareSubsystemTablesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 64px;
`;
